// extracted by mini-css-extract-plugin
module.exports = {"brandBg":"#1c1c1c","brandHl":"#e1ff00","white":"#fff","grey":"gray","black":"#000","textColor":"#fff","textColorMute":"hsla(0,0%,100%,.6)","cardBgColor":"#282828"};